<template>
  <div class="account">
    <Button layout="back" @click="router.back()" class="show-s">
      <i class="fa fa-arrow-left"></i> Voltar
    </Button>
    <div class="title row grid-12 wrap">
      Configurações da&nbsp;<strong>Conta</strong>
    </div>
    <div class="row-g column-m grid-10">
      <form
        :class="
          user.perfil == 'doutor'
            ? 'grid-6-g grid-11-m grid-10-s'
            : 'grid-6-g grid-11-m grid-11-s'
        "
        class="box column list"
        onsubmit="return false"
        @submit="updatePass"
      >
        <div class="title">Alterar senha</div>
        <div class="row column-s">
          <div class="grid-4 grid-12-s field">
            <label>Senha atual</label>
            <input
              type="password"
              class="input"
              v-model="dados.senha_atual"
              placeholder="Senha"
              required
            />
          </div>
          <div class="grid-4 grid-12-s field">
            <label>Nova senha</label>
            <input
              type="password"
              class="input"
              v-model="dados.nova_senha"
              placeholder="Nova senha"
              required
            />
          </div>
          <div class="grid-4 grid-12-s field">
            <label>Confirmar nova senha</label>
            <input
              type="password"
              class="input"
              v-model="confirm"
              placeholder="Confirmar nova senha"
              required
            />
          </div>
        </div>

        <div class="row column-s margin-top">
          <div class="grid-6 hide-s">
            <Button layout="white-m-gray" @click="router.back()">
              <i class="fa fa-arrow-left"></i> Voltar
            </Button>
          </div>

          <div class="grid-6 grid-12-s justify-end justify-center-s row">
            <Button :loader="loader" layout="green-m" :disabled="loader"
              >SALVAR ALTERAÇÃO</Button
            >
          </div>
        </div>
      </form>

      <div class="box grid-6-g grid-12 grid-11-m grid-10-s column-2 column">
        <div class="title">Desativar a conta</div>
        <div class="row delAccount">
          <div v-if="pendency.length == 0">
            Se você realmente deseja desativar sua conta basta clicar no botão
            abaixo.
          </div>
          <div v-else>
            <ul class="pendency">
              <li v-for="(p, i) of pendency" :key="'p' + i">
                Você precisa encerrar as pendências do Job
                <strong>#{{ p.id }}</strong> antes de desativar
              </li>
            </ul>
          </div>
        </div>
        <div class="row margin-top ac js">
          <div class="row ac text-red" v-if="pendency.length == 0 || user.perfil == 'agregado_doutor'">
            <input type="checkbox" v-model="del" style="margin-right: 20px" /> 
            Excluir permanentemente seus
            dados?<br />
            Essa ação é irreversível.
          </div>
          <Button
            v-if="pendency.length == 0 || user.perfil == 'agregado_doutor'"
            :loader="loader"
            layout="red-go"
            :disabled="loader"
            @click="disable"
            >DESATIVAR A CONTA</Button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import Button from "@/components/Button.vue";
import Router from "@/router";
export default {
  name: "Config",
  components: { Button },
  data() {
    return {
      dados: {},
      confirm: "",
      loader: false,
      pendency: [],
      router: Router,
      del: false,
    };
  },
  beforeMount() {
    if (this.user && this.user.perfil == "doutor")
      this.DISABLE_PENDENCY().then((r) => (this.pendency = r));
  },
  methods: {
    ...mapActions("general", [
      "UPDATE_PASS",
      "DISABLE_SUPPORTER_ACCOUNT",
      "DISABLE_PENDENCY",
    ]),
    ...mapActions("admin", ["DEL_AGGREGATE_SUPPORTER"]),
    ...mapMutations("general", ["SET_STATUS"]),
    disable() {
      if (confirm("Você realmente deseja desativar sua conta?")) {
        if (this.user.perfil == "doutor")
          this.DISABLE_SUPPORTER_ACCOUNT({ excluir_dados: this.del });

        if (this.user.perfil == "agregado_doutor")
          this.DEL_AGGREGATE_SUPPORTER({ id: this.user.id_agregado_doutor, del: this.del });
      }
    },
    updatePass() {
      this.loader = true;
      if (this.confirm !== this.dados.nova_senha) {
        this.loader = false;
        this.SET_STATUS({
          text: "Senhas não coincidem",
          color: "red",
          notify: "Senhas não coincidem",
        });
      } else {
        this.UPDATE_PASS(this.dados).then(() => {
          this.loader = false;
          this.confirm = "";
          this.dados = {};
        });
      }
    },
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>


<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.account {
  padding-bottom: 50px;
  padding: 20px 40px;
  @media (max-width: $medium) {
    padding: 15px;
  }
  .title {
    padding: 20px 0px;
    font-size: 26px;
    
    @media (max-width: $small) {
      margin-top: 38px;
    }
    strong {
      color: $supporter-1;
    }
  }
  .list {
    background: $white;
    @media (max-width: $small) {
      margin-top: 50px;
    }
  }
  .field {
    padding-right: 20px;
    margin-bottom: 25px;
  }
  .box {
    border-radius: 21px;
    background: $white;
    box-shadow: $shadow;
    padding: 35px 40px;
    .title {
      font-size: 20px;
    }
    label {
      color: $gray-6;
      font-size: 15px;
      line-height: 30px;
    }
    @media (min-width: $large) {
      margin-left: 38px;
    }
    @media (max-width: $large) {
      margin-top: 40px;
    }
  }

  .margin-top {
    margin-top: 55px;
  }
  .back {
    color: $white;
    z-index: 99;
    width: 200px;
    background: none;
    font-size: 14px;
    font-weight: bold;
    padding-bottom: 20px;
    i {
      margin-right: 10px;
    }
    margin-left: -45px;
    margin-bottom: 5px;
  }

  .empty {
    height: 100vh;
  }

  .delAccount {
    min-height: 100px;
  }
  .button-red-go {
    height: 43px;
    @media (max-width: $small) {
      width: 162px;
      height: 40px;
    }
  }
  .pendency {
    li {
      background: #fcefef;
      color: #a26e6e;
      padding: 15px 25px;
      border-radius: 5px;
    }
  }
}
</style>
